<script setup lang="ts">
import { computed } from 'vue';
import { useWelcomeMessageCustomisation } from '../composables/useWelcomeMessageCustomisation';
import { replacePlaceholders, sanitizeHTML } from '@/common/utils';
import { useBotUser } from '@/stores/useBotUser';
import { storeToRefs } from 'pinia';

const customisation = useWelcomeMessageCustomisation();

const userStore = useBotUser();
const { user } = storeToRefs(userStore);

const mainTextStyle = computed(() => {
  const color = customisation.mainTextColor.value;
  return color ? { color } : {};
});

const placeholderStyle = computed(() => {
  const color = customisation.placeholderColor.value;
  return color ? { color } : {};
});

const mainTextContent = computed(() => {
  return sanitizeHTML(
    replacePlaceholders(customisation.mainTextContent.value, {
      user: {
        name: `<span style="color: ${placeholderStyle.value.color};">${user.value.displayName}</span>`,
      },
    })
  );
});

const shouldRenderMainText = computed(() => {
  if (!customisation.mainTextVisible.value) {
    return false;
  }
  return customisation.mainTextContent.value?.trim() !== '';
});

const subTextStyle = computed(() => {
  const color = customisation.subTextColor.value;
  return color ? { color } : {};
});

const shouldRenderSubText = computed(() => {
  if (!customisation.subTextVisible.value) {
    return false;
  }

  return customisation.subTextContent.value?.trim() !== '';
});
</script>

<template>
  <div class="welcome-message">
    <h1 v-if="shouldRenderMainText" class="main-text theme-font-h1" :style="mainTextStyle" v-html="mainTextContent" />
    <p v-if="shouldRenderSubText" class="sub-text theme-font-main" :style="subTextStyle">
      {{ customisation.subTextContent.value }}
    </p>
  </div>
</template>

<style scoped lang="scss">
.welcome-message {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.main-text {
  margin: 0;
  line-height: 1.3;
  overflow-wrap: anywhere;
}

.sub-text {
  margin: 0;
  line-height: 1.5;
}
</style>
